import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { fmt, fmtDateShort } from '../lib/format';
import { ShieldCheck, Trash } from '@phosphor-icons/react';

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/audit/deleted-orders').then(r => { setLogs(r.data); setLoading(false); });
  }, []);

  return (
    <div className="space-y-5 fade-in" data-testid="audit-page">
      <div>
        <h1 className="text-2xl font-semibold text-white tracking-tight">删除订单日志</h1>
        <p className="text-sm text-slate-400 mt-0.5">所有被删除的订单都会记录在这里 — 用来监督员工的操作</p>
      </div>

      {loading && <div className="card-base p-12 text-center text-slate-500">加载中…</div>}

      {!loading && logs.length === 0 && (
        <div className="card-base p-12 text-center">
          <ShieldCheck size={40} weight="duotone" className="text-slate-700 mx-auto mb-3" />
          <p className="text-slate-500">还没有删除记录</p>
        </div>
      )}

      {!loading && logs.length > 0 && (
        <div className="space-y-2">
          {logs.map(log => {
            const o = log.order_snapshot || {};
            return (
              <div key={log.id} className="card-base p-4 border-rose-500/20">
                <div className="flex items-start justify-between gap-3 mb-2">
                  <div className="flex items-center gap-3 min-w-0">
                    <div className="w-10 h-10 rounded-lg bg-rose-500/10 border border-rose-500/30 flex items-center justify-center flex-shrink-0">
                      <Trash size={18} weight="duotone" className="text-rose-400" />
                    </div>
                    <div className="min-w-0">
                      <div className="text-sm font-semibold text-white">
                        删除人:<span className="text-rose-300">{log.user_name}</span>
                      </div>
                      <div className="text-xs text-slate-500 font-num">{fmtDateShort(log.created_at)}</div>
                    </div>
                  </div>
                  {log.reason && (
                    <div className="text-xs text-amber-300 bg-amber-500/10 border border-amber-500/20 rounded px-2 py-1 max-w-[40%] truncate">
                      原因:{log.reason}
                    </div>
                  )}
                </div>
                <div className="bg-slate-900/60 rounded-lg p-3 border border-slate-800 text-sm space-y-1">
                  <div className="flex justify-between">
                    <span className="text-slate-500">客户:</span>
                    <span className="text-slate-200 truncate ml-2">{o.customer_email}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-slate-500">金额:</span>
                    <span className="font-num text-white">{fmt(o.amount)} {o.currency}</span>
                  </div>
                  {o.sell_rate && (
                    <div className="flex justify-between">
                      <span className="text-slate-500">卖出汇率:</span>
                      <span className="font-num text-slate-200">{o.sell_rate}</span>
                    </div>
                  )}
                  <div className="flex justify-between">
                    <span className="text-slate-500">手续费%:</span>
                    <span className="font-num text-slate-200">{o.fee_percent}%</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-slate-500">Net USDT:</span>
                    <span className="font-num text-emerald-300">{fmt(o.net_usdt)}</span>
                  </div>
                  <div className="flex justify-between text-xs">
                    <span className="text-slate-500">录单员工:</span>
                    <span className="text-slate-400">{o.employee_name}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
